module.exports = __webpack_public_path__ + "img/map-point-rotate.46414054.svg";